export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-1200-574b861a7e76de73b03946bf2dffb97f.webp";